import React from "react";
import RenminContent from "../../components/layouts/tentang/RenminContent";

const Renmin: React.FC = () => {
  return (
    <div>
      <RenminContent />
    </div>
  );
};

export default Renmin;
